import { call, put } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { IS_APP } from '../../services/target';

import { Creators as MessagesCreators } from '../ducks/messages';
import { Creators as PasswordCreators } from '../ducks/password';

import api from '../../services/api';

export function* forgot(action) {
  let to = '/password/pin';

  const response = yield call(api.post, 'v1/customers/password/reset', {
    customer: { ...action.payload },
  });

  if (action.payload.type === 'email') {
    to = '/signin';
    if (IS_APP) {
      window.ReactNativeWebView.postMessage(JSON.stringify({
        type: 'forgot_password',
        success: true,
        message:
            'Enviaremos um e-mail com as instruções para o e-mail digitado, caso ele esteja cadastrado.',
      }));
    } else {
      yield put(MessagesCreators.setMessage(
        'Enviaremos um e-mail com as instruções para o e-mail digitado, caso ele esteja cadastrado.',
        'success',
        true,
      ));
    }
  } else {
    if (response.status === 200) {
      yield put(MessagesCreators.setMessage(
        'Enviaremos um SMS com o CÓDIGO para o seu celular, caso ele esteja cadastrado.',
        'success',
        true,
      ));
    }
    if (response.status === 201) {
      to = '/signin';
      if (IS_APP) {
        window.ReactNativeWebView.postMessage(JSON.stringify({
          type: 'forgot_password',
          success: true,
          message:
              'Enviaremos um SMS com uma nova senha para o seu celular, caso ele esteja cadastrado.',
        }));
      } else {
        yield put(MessagesCreators.setMessage(
          'Enviaremos um SMS com uma nova senha para o seu celular, caso ele esteja cadastrado.',
          'success',
          true,
        ));
      }
    }
  }

  yield put(PasswordCreators.success());
  if (IS_APP) to += '?target=app';
  yield put(push(to));
}

export function* checkPin(action) {
  const response = yield call(api.post, 'v1/customers/password/check_pin', {
    customer: { ...action.payload },
  });

  yield put(PasswordCreators.success());

  if (!response.ok) {
    yield put(MessagesCreators.setMessage('Código inválido', 'danger'));
    return;
  }

  yield put(push(`/password/edit/${response.data.token}${IS_APP ? '?target=app' : ''}`));
}



// WEBPACK FOOTER //
// ./src/store/sagas/password.js